import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function get_onboarding(params = {}) {
  return request({
    url: global.endpoint.USERS_ME_ONBOARDING_PROCESS,
    method: "get",
    params
  });
}

async function update_onboarding(data = {}) {
  return request({
    url: global.endpoint.USERS_ME_ONBOARDING_PROCESS,
    method: "put",
    data
  });
}

export default {
  get_onboarding,
  update_onboarding
};
